<ng-container *ngIf="hasAdministrationAccess">
    <h3 class="title">Administration</h3>
    <h4 class="sr-only">Administration Section</h4>
    <div class="info-card flex gap-m">
        <a target="_blank" [href]="adminUrl" class="flex gap-m">
            <global-home-icon
                class="icon"
                [svg]="badgeSvg"
                [size]="16">
            </global-home-icon>
            <div>
                <h5 class="heading">
                Administration
                </h5>
                <div class="description text-dark text-size-s">
                    Manage users and product access, monitor data usage and allowances (Consumer Intelligence only)
                </div>
            </div>
        </a>
    </div>
</ng-container>
<h3 class="title">Help & support</h3>
<h4 class="sr-only">Info Section</h4>
<div *ngFor="let item of helpAndUpdateTemplate" class="info-card flex gap-m">
    <ng-container *ngIf="item.url && !item.options?.length; else showItemWithOptions">
        <a target="_blank" href="{{item.url}}" class="flex gap-m" (click)="dispatchTrackEvent(item.name)">
            <global-home-icon
                class="icon"
                [svg]="item.icon"
                [size]="16">
            </global-home-icon>
            <div>
                <h5 class="heading">
                    {{item.name}}
                </h5>
                <div class="description text-dark text-size-s">
                    {{item.description}}
                </div>
            </div>
        </a>
    </ng-container>
    <ng-template #showItemWithOptions>
        <global-home-icon
            class="icon"
            [svg]="item.icon"
            [size]="16">
        </global-home-icon>
        <div>
            <div>
                <global-home-dropdown
                    [buttonText]="item.name"
                    [selectList]="item.options || []">
                </global-home-dropdown>
            </div>
            <div class="description text-dark text-size-s">
                {{item.description}}
            </div>
        </div>
    </ng-template>
</div>
